import NewHireEditorActionTypes from './new-hire-ref.types';
const INITIAL_STATE = {
  data: null,
  error: null,

  departments: '',
  positions: '',
  localDistros: [],

  currDepartment: '',
  currPosition: '',

  currGoogleGroups: null,
  currAzureGroups: null,

  currNoc: null,
  currNavitaire: null,
  currUber: null,
  currLyft: null,
};

const newHireEditorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NewHireEditorActionTypes.GET_NEW_HIRE_EDITOR_DATA_SUCCESS:
      return { ...state, error: null, data: action.payload };

    case NewHireEditorActionTypes.GET_NEW_HIRE_EDITOR_DATA_FAILURE:
      return { ...state, error: action.payload, data: null };

    case NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_DEPARTMENTS:
      return { ...state, departments: action.payload };

    case NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_POSITIONS:
      return { ...state, positions: action.payload };

    case NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_DEPARTMENT:
      return { ...state, currDepartment: action.payload };

    case NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_POSITION:
      return { ...state, currPosition: action.payload };

    case NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_LOCAL_DISTROS:
      return { ...state, localDistros: action.payload };

    case NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_GOOGLE_GROUPS:
      return { ...state, currGoogleGroups: action.payload };

    case NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_AZURE_GROUPS:
      return { ...state, currAzureGroups: action.payload };

    case NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_NOC:
      return { ...state, currNoc: action.payload };

    case NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_NAVITAIRE:
      return { ...state, currNavitaire: action.payload };

    case NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_UBER:
      return { ...state, currUber: action.payload };

    case NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_LYFT:
      return { ...state, currLyft: action.payload };

    default:
      return state;
  }
};

export default newHireEditorReducer;
